/* eslint-disable */
<template>
  <v-container>
    <v-card>
      <v-card-title>My Financials</v-card-title>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="financials"
        dense
        class="elevation-1"
        item-key="reg_no"
        fixed-header
      >
        <template v-slot:[`item.controls`]>
          <v-btn x-small outlined color="accent" class="mx-1"> view </v-btn>
          <v-btn x-small text color="primary"> register </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "FinancialsComponent",
  data: () => ({
    financials: [],
    headers: [
      { text: "Reg. No", sortable: false, value: "registrationID" },
      {
        text: "Programme",
        align: "start",
        sortable: false,
        value: "programme",
      },
      { text: "Year", sortable: false, value: "intakeYear" },
      { text: "Semester", sortable: false, value: "intakeSemester" },
      { text: "Stage", sortable: false, value: "intakeStage" },
      { text: "Amount Paid", value: "amountPaid" },
      { text: "Balance", value: "balance" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "controls", sortable: false },
    ],
  }),
};
</script>
